import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cx from 'classnames';
import Icon from 'shared/components/Icon';
import NumberBadge from './NumberBadge';

const NavLink = ({ path, label, icon, numberBadge }, context) => {
  const classes = cx({ active: context.router.isActive(path) });
  return (
    <li className={classes}>
      {' '}
      {/* TODO: Add active class as appropriate */}
      <Link to={path}>
        <div className="sidebar-icon">
          <Icon name={icon} />
        </div>
        <span>{label}</span>
        <NumberBadge number={numberBadge} />
      </Link>
    </li>
  );
};

NavLink.displayName = 'NavLink';

NavLink.contextTypes = { router: PropTypes.object };

NavLink.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  numberBadge: PropTypes.number,
};

export default NavLink;
